module.exports = __webpack_public_path__ + "img/播种移栽图标.d4c4eb43.svg";